// validation/dynamicFileValidationSchema.ts

import * as Yup from 'yup';

interface FieldDefinition {
  name: string;
  label: string;
  required: boolean;
}

export const generateFileValidationSchema = <T>(
  fields: FieldDefinition[]
): Yup.ObjectSchema<any> => {
  return Yup.object().shape(
    fields.reduce((acc: Record<string, Yup.MixedSchema>, field) => {
      const fileSchema = Yup.mixed()
        .test(
          "fileSize",
          `${field.label} must be less than or equal to 1MB`,
          (value) => {
            // Support both browser and Node environments
            if (value && typeof value === "object" && "size" in value) {
              return (value as { size: number }).size <= 1024 * 1024;
            }
            return true;
          }
        )
        .test(
          "fileType",
          `${field.label} must be a PDF, JPEG, or PNG file`,
          (value) => {
            if (value && typeof value === "object" && "type" in value) {
              return ["application/pdf", "image/jpeg", "image/png"].includes(
                (value as { type: string }).type
              );
            }
            return true;
          }
        );

      acc[field.name] = field.required
        ? fileSchema.required(`${field.label} is required`)
        : fileSchema;

      return acc;
    }, {} as Record<string, Yup.MixedSchema>)
  );
};
